import $ from 'jquery';

/**
 * @param {JQuery.Event} e
 */
const confirmEvent = (e) => {
    confirm('Είστε σίγουροι;') || e.preventDefault();
};

$(() => {
    $('form.js-confirmation').on('submit', confirmEvent);
    $('a.js-confirmation').on('click submit', confirmEvent);
});
